import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../global-services/auth.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class DeviceGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        // Uncomment next line for local testing
        // return true;
        return this.authService.isMobileDevice$.pipe(
            tap((isMobileDevice) => {
                if (!isMobileDevice) {
                    this.router.navigate(['/desktop-landing']);
                    return;
                }
            }),
            map((isMobileDevice) => isMobileDevice) // Allow access only if it's a mobile device
        );
    }
}
